import React from "react";
import { Box, TextField, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicTextField = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic TextField
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          The TextField wrapper component is a complete form control including a
          label, input, and help text. It comes with three variants: outlined
          (default), filled, and standard.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"Three variants of text field. outlined, filled and standard"}
          language={"js"}
          value={
            '         <TextField />\n' +
            '          <TextField variant="filled" />\n' +
            '          <TextField variant="standard" />'
          }
        >
          <TextField />
          <TextField variant="filled" />
          <TextField variant="standard" />
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default BasicTextField;
